"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = require("webmotors-react-pj/frame/footer/logged/style");
var _date = _interopRequireDefault(require("webmotors-react-pj/frame/footer/logged/date"));
var _brands = _interopRequireDefault(require("webmotors-react-pj/frame/footer/logged/brands"));
var _default = () => _react.default.createElement(_style.StyleFooter, null, _react.default.createElement(_style.StyleContainer, null, _react.default.createElement(_date.default, null), _react.default.createElement(_brands.default, null)));
exports.default = _default;